<template>
    <v-dialog v-model="dialog" width="700" persistent>
        <template v-slot:activator="{ on, attrs }">
            <v-btn fab x-small v-bind="attrs" v-on="on" color="primary" outlined>
                <v-icon x-small>fas fa-edit</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Modify Services Controls
            </v-card-title>

            <v-card-text v-if="current.rules.roles && current.rules.roles[targetRole]">
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-checkbox v-model="current.rules.roles[targetRole].enable" label="Override Service Rules" :disabled="loading"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row v-if="current.rules.roles[targetRole].enable">
                        <v-col cols="12" sm="9">
                            <v-select v-model="current.rules.roles[targetRole].methods" :items="['get', 'find', 'create', 'patch', 'update', 'remove']" chips label="Methods" multiple :disabled="serviceMS(current).default || loading"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-checkbox v-model="serviceMS(current).default" label="Use Default" :disabled="loading"></v-checkbox>
                        </v-col>

                        <!-- <v-col cols="12" sm="9">
                            <v-select v-model="current.rules.roles[targetRole].authenticate" :items="['get', 'find', 'create', 'patch', 'update', 'remove']" chips label="Authentication Required" multiple :disabled="serviceAS(current).default"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-checkbox v-model="serviceAS(current).default" label="Use Default"></v-checkbox>
                        </v-col> -->

                        <v-col cols="12" sm="4">
                            <v-checkbox v-model="current.rules.roles[targetRole].owner.enable" label="Set Owner Field" :disabled="loading"></v-checkbox>
                        </v-col>
                        <feathers-vuex-get v-if="current.rules.roles[targetRole].owner.enable" service="model-props" :id="item.id">
                            <v-col cols="12" sm="8" slot-scope="{ item: Attributes, isGetPending }">
                                <v-select v-if="!isGetPending" v-model="current.rules.roles[targetRole].owner.field" :items="Attributes.col" label="Target Attribute" :disabled="loading"></v-select>
                                <v-progress-circular v-else indeterminate color="red"></v-progress-circular>
                            </v-col>
                        </feathers-vuex-get>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!loading" small color="red" text @click="dialog = false">Cancel</v-btn>
                <v-btn small color="primary" text @click="updateService(current)" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default() {
                return null;
            }
        },
        targetRole: String
    },
    data() {
        return {
            dialog: false,
            current: Object.assign({}, this.item),
            loading: false,
            successMessage: false,
            error: {
                show: false,
                message: ''
            }
        };
    },
    mounted() {
        if(!this.current.rules.roles) {
            this.$set(this.current.rules, 'roles', {});
        }
        if(!this.current.rules.roles[this.targetRole]) {
            this.$set(this.current.rules.roles, this.targetRole, {
                enable: false,
                methods: ['all'],
                authenticate: ['all'],
                owner: {
                    enable: false,
                    field: 'user_id'
                }
            });
        }
    },
    methods: {
        serviceMS(item) {
            const self = this;
            return {
                get default() {
                    return item.rules.roles[self.targetRole].methods.indexOf('all') !== -1;
                },
                set default(value) {
                    if(value) {
                        item.rules.roles[self.targetRole].methods = ['all'];
                    } else {
                        item.rules.roles[self.targetRole].methods = [];
                    }
                }/*,
                get model() {
                    return null;
                },
                set model(value) {

                }*/
            };
        },
        serviceAS(item) {
            const self = this;
            return {
                get default() {
                    return item.rules.roles[self.targetRole].authenticate.indexOf('all') !== -1;
                },
                set default(value) {
                    if(value) {
                        item.rules.roles[self.targetRole].authenticate = ['all'];
                    } else {
                        item.rules.roles[self.targetRole].authenticate = [];
                    }
                }
            };
        },
        async updateService(item) {
            try {
                this.loading = true;
                this.item.rules = item.rules;
                await this.item.update();
                this.$emit('success');
                this.dialog = false;
            } catch(err) {
                this.$emit('error', err);
            } finally {
                this.loading = false;
            }
        }
    },
}
</script>